// src/App.tsx
import React from "react";
import AppRouter from "./router";
import { ThemeProvider } from "./providers/ThemeProvider";
import { useAuthStore } from "./stores/authStore";
import AuthGate from "./providers/AuthGate";
import LoadingSpinner from "./components/LoadingSpinner";

export default function App(): React.ReactElement {
  const start = useAuthStore((s) => s.start);
  const status = useAuthStore((s) => s.state.status);

  React.useEffect(() => {
    let cancelled = false;
    (async () => {
      // NO fijes persistencia aquí otra vez; ya lo hace AuthGate/setupAuthPersistence
      if (!cancelled) start();
    })();
    return () => {
      cancelled = true;
    };
  }, [start]);

  if (status === "loading") {
    return (
      <ThemeProvider>
        <div className="min-h-screen bg-app text-app">
          <LoadingSpinner fullscreen label="Preparando tu sesión…" />
        </div>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      <AuthGate>
        <div className="min-h-screen bg-app text-app">
          <AppRouter />
        </div>
      </AuthGate>
    </ThemeProvider>
  );
}
